// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2021 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

#theia-drag-panel {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 4px);
  margin: 4px;
  -webkit-app-region: drag !important;
}

#theia-top-panel > * {
  -webkit-app-region: no-drag;
}

#theia-custom-title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
  line-height: 30px;
  flex: 0 1 auto;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 2px;
  margin-left: auto;
  margin-right: auto;
  zoom: 1;
  -webkit-app-region: drag !important;
}

#theia-custom-title.relative {
  transform: none;
}

#theia-custom-title.hidden {
  visibility: hidden;
}

#window-controls {
  display: grid;
  grid-template-columns: repeat(3, 48px);
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}

#window-controls .control-button {
  display: flex;
  line-height: 30px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#minimize-button {
  grid-column: 1;
}

#maximize-button,
#restore-button {
  grid-column: 2;
}

#close-button {
  grid-column: 3;
}

#window-controls .control-button {
  user-select: none;
}

#window-controls .control-button:hover {
  background: rgba(50%, 50%, 50%, 0.2);
}

#window-controls #close-button:hover {
  background: #e81123;
}

#window-controls #close-button:hover:before {
  color: white;
}

body:not(.maximized) #restore-button {
  display: none;
}

body.maximized #maximize-button {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/electron-browser/menu/electron-menu-style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,OAAO;EACP,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":["/********************************************************************************\n * Copyright (C) 2021 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n#theia-drag-panel {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: calc(100% - 4px);\n  margin: 4px;\n  -webkit-app-region: drag !important;\n}\n\n#theia-top-panel > * {\n  -webkit-app-region: no-drag;\n}\n\n#theia-custom-title {\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0px);\n  line-height: 30px;\n  flex: 0 1 auto;\n  font-size: 12px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-top: 2px;\n  margin-left: auto;\n  margin-right: auto;\n  zoom: 1;\n  -webkit-app-region: drag !important;\n}\n\n#theia-custom-title.relative {\n  transform: none;\n}\n\n#theia-custom-title.hidden {\n  visibility: hidden;\n}\n\n#window-controls {\n  display: grid;\n  grid-template-columns: repeat(3, 48px);\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n}\n\n#window-controls .control-button {\n  display: flex;\n  line-height: 30px;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n#minimize-button {\n  grid-column: 1;\n}\n\n#maximize-button,\n#restore-button {\n  grid-column: 2;\n}\n\n#close-button {\n  grid-column: 3;\n}\n\n#window-controls .control-button {\n  user-select: none;\n}\n\n#window-controls .control-button:hover {\n  background: rgba(50%, 50%, 50%, 0.2);\n}\n\n#window-controls #close-button:hover {\n  background: #e81123;\n}\n\n#window-controls #close-button:hover:before {\n  color: white;\n}\n\nbody:not(.maximized) #restore-button {\n  display: none;\n}\n\nbody.maximized #maximize-button {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
